module.exports = __webpack_public_path__ + "img/leafs.c2e266ef.svg";